import {Component, effect, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterModule} from "@angular/router";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {CommonModule, isPlatformBrowser, NgClass, NgIf, NgTemplateOutlet} from "@angular/common";
import {SideBarComponent} from "@cybfed/ui-lib/side-bar/side-bar.component";
import {UserStore} from "@cybfed/core/store/user.store";
import {PageBuilderStore} from "@white-label/components/page-builder/page-builder.store";
import {StorageService} from "@cybfed/core/services/storage.service";
import {customSetInterval} from "@cybfed/core/helpers/overrided-timers";
import {AuthenticationService} from "@cybfed/core/services/authentication.service";
import {SocketConnect} from "@cybfed/core/services/socket/socket-connect";

@Component({
  selector: 'white-label-mobile-menu',
    templateUrl: './side-bar-menu.component.html',
    standalone: true,
    imports: [
        TranslateModule,
        RouterLink,
        RouterModule,
        NgClass,
        SideBarComponent,
        CommonModule,
    ],
    providers: [
        AuthenticationService
  ]
})
export class SideBarMenuComponent implements OnInit{
    @Input() editMode: boolean = false;

    shown: boolean = false;
    componentData: any;
    whiteLabel: any;
    platformAdminRole: any;
    currentUrl: string = '';
    currentSlug: any
    inPageBuilderPage = false
    public currentUser: any;

    constructor(
                public mainStoreService: MainStoreService,
                public pageBuilderStore: PageBuilderStore,
                public route: ActivatedRoute,
                public router: Router,
                public userStore: UserStore,
                private socketComponent: SocketConnect,
                private authenticationService: AuthenticationService,
                @Inject(PLATFORM_ID) private platformId: any,
    ) {
        effect(() => {
            if(this.userStore?.currentUser){
                this.currentUser = this.userStore?.currentUser
            }
        });
        if(this.userStore?.currentUser?.whiteLabels){
            let roleIndex = this.userStore?.currentUser.whiteLabels.findIndex(l => l.whiteLabelId == this.userStore?.currentUser?.whiteLabelId);
            if(roleIndex >= 0){
                this.platformAdminRole = this.userStore?.currentUser?.whiteLabels[roleIndex].role
            }
        }
        this.whiteLabel = this.mainStoreService.whiteLabel

        this.currentUrl = this.router.url;


        // // Use a regular expression to extract the slug from the URL
        const slugMatch = this.currentUrl.match(/p\/([^\/]+)/);
        if (slugMatch && slugMatch[1]) {
            this.currentSlug = slugMatch[1]; // Extract slug from URL
        }
        if (this.currentUrl.includes('page-builder')) {
            this.inPageBuilderPage = true
        }



    }

    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = event.url;
                const slugMatch = this.currentUrl.match(/p\/([^\/]+)/);
                if (slugMatch && slugMatch[1]) {
                    this.currentSlug = slugMatch[1];
                }
                if (this.currentUrl.includes('page-builder')) {
                    this.inPageBuilderPage = true
                }
            }
        });
    }

    isActive(url: string): boolean {
        return this.currentUrl === url;
    }

    closeMenu(): boolean {
        return this.shown = !this.shown;
    }

    menuNavigation(value: string){
        if (this.inPageBuilderPage && this.currentSlug) {
            this.router.navigate(['page-builder/' + value])
        }else {
            this.router.navigate([value])
        }

    }
    async logOut() {
        // this.onClose();
        let lang = StorageService.getItem(StorageService.statics.lang)
        let currency = StorageService.getItem(StorageService.statics.currency)
        // this.router.navigate(['/auth/signin'])
        this.authenticationService.logout().subscribe((data: any) => {
            StorageService.clear()
            let interval = customSetInterval(() =>{
                if(!StorageService.getToken()){
                    clearInterval(interval);
                    StorageService.setItem(StorageService.statics.lang, lang);
                    StorageService.setItem(StorageService.statics.currency, currency);
                    this.socketComponent.disconnect();
                    this.router.navigate(['/']).then(()=>{
                        if(isPlatformBrowser(this.platformId)) {
                            location.reload();
                        }
                    });
                }
            },10);
        })

    }
}


